import { useQuery } from '@apollo/client';
import { FilterFieldProps } from '../types';
import { getDataForTransformationsQuery } from '../../../../api/queries';
import { GetDataForTransformationsQuery } from '../../../../graphql/graphql';
import { getPashaFilterDataQuery } from '../../../../api/queries/pasha';
import { getBasedDataStatValueInFilters } from '../../../../utils/helpers/common';
import { ItemConnectionSort } from '../../../../graphql/types';
import useScreenSize from '../../../../hooks/useScreenSize';
import { useSorting } from '../../../../hooks/useSorting';
import { PriceViewMode } from '../../../GeneralAdsPage/types';
import { denormalizeSort } from '../../../../utils/helpers/sortMapping';
import { useClient } from '../../../../hooks/useClient';
import { ItemsSortingFilter } from './ItemsSortingFilter';

export const SortingFilter = ({
  submitOnChange = false,
  isPerUnit = false,
  showIcon = true,
  initialSort,
  isPashaLanding,
  disabled = false
}: FilterFieldProps) => {
  const { isSmall } = useScreenSize();
  const isClient = useClient();
  const { currentSort, updateSort } = useSorting();
  const currentSortValue = denormalizeSort(initialSort || currentSort);
  const basedDataStat = getBasedDataStatValueInFilters(isPashaLanding);

  const { data } = useQuery<GetDataForTransformationsQuery>(
    isPashaLanding ? getPashaFilterDataQuery : getDataForTransformationsQuery,
    { fetchPolicy: isPashaLanding ? 'cache-first' : 'cache-only' }
  );

  const isIconShown = isPashaLanding
    ? showIcon
    : (!isSmall && isClient) || !isClient;

  const onFilterChange = (sortValue: ItemConnectionSort) =>
    updateSort(
      sortValue,
      isPerUnit ? PriceViewMode.PerAcre : PriceViewMode.PerArea,
      { sortData: data?.sort, isPashaLanding }
    );

  return (
    <ItemsSortingFilter
      currentSortValue={currentSortValue}
      submitOnChange={submitOnChange}
      showIcon={isIconShown}
      disabled={disabled}
      dataStat={basedDataStat}
      onChange={onFilterChange}
    />
  );
};
